import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import type { ComponentProps } from 'react';
import { useMemo } from 'react';

import { StatsIcon as DumbStatsIcon } from '@sorare/core/src/components/draft/StatsIcon';
import { normalizeStatsFromRawScores } from '@sorare/core/src/lib/performance';

import type { AnyPlayerFifteenStatsIcon_anyPlayer } from './__generated__/index.graphql.ts';

type Props = {
  player: AnyPlayerFifteenStatsIcon_anyPlayer;
  onClick?: ComponentProps<typeof DumbStatsIcon>['onClick'];
} & Pick<ComponentProps<typeof DumbStatsIcon>, 'outlined' | 'backgroundColor'>;

export const AnyPlayerFifteenStatsIcon = ({
  player,
  onClick,
  ...dumbStatIconProps
}: Props) => {
  const stats = useMemo(() => {
    return normalizeStatsFromRawScores(
      player.rawFifteenPlayerGameScores,
      player.sport,
      15
    );
  }, [player.rawFifteenPlayerGameScores, player.sport]);

  return (
    <DumbStatsIcon
      stats={stats}
      onClick={onClick}
      {...dumbStatIconProps}
      width={10}
      height={4}
    />
  );
};

AnyPlayerFifteenStatsIcon.fragments = {
  anyPlayer: gql`
    fragment AnyPlayerFifteenStatsIcon_anyPlayer on AnyPlayerInterface {
      slug
      rawFifteenPlayerGameScores: rawPlayerGameScores(last: 15)
      sport
    }
  ` as TypedDocumentNode<AnyPlayerFifteenStatsIcon_anyPlayer>,
};
